import React from "react";

const BedBathSelector = ({
  bedrooms,
  setBedrooms,
  bathrooms,
  setBathrooms,
  useDropdown = true  // Toggle between dropdown or input mode
}) => {
  const dropdownOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4+" }
  ];

  const renderField = ({ label, value, onChange, placeholder, min, step = 1, isDropdown }) => {
    return (
      <div>
        <label className="block font-semibold mb-1">{label}:</label>
        {isDropdown ? (
          <select
            className="border rounded px-2 py-1 w-full"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            <option value="">Any</option>
            {dropdownOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        ) : (
          <input
            type="number"
            min={min}
            step={step}
            className="border rounded px-2 py-1 w-full"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
          />
        )}
      </div>
    );
  };

  return (
    <div className="flex space-x-4 mb-4">
      <div className="flex-1">
        {renderField({
          label: "Bedrooms",
          value: bedrooms,
          onChange: setBedrooms,
          placeholder: "e.g., 3",
          min: 0,
          isDropdown: useDropdown
        })}
      </div>
      <div className="flex-1">
        {renderField({
          label: "Bathrooms",
          value: bathrooms,
          onChange: setBathrooms,
          placeholder: "e.g., 2",
          min: 0,
          step: 0.5,
          isDropdown: useDropdown
        })}
      </div>
    </div>
  );
};

export default BedBathSelector;